import gsap from 'gsap';
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class {
	constructor() {
        this.init();
    }

    init() {
        gsap.matchMedia({
            "(min-width: 992px)": () => {
                const indexBusiness = document.querySelector("#p-index__business");
                if (indexBusiness) {
                    this.indexBusiness = ScrollTrigger.create({
                        trigger: "#p-index__business",
                        start: "bottom bottom",
                        end: "bottom top",
                        pin: true,
                        pinSpacing: false
                    });
                }
            }
        });
    }
}
